module.exports = __webpack_public_path__ + "static/media/icon_split.bb7407e7.svg";